package org.gymly.ui.components

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Visibility
import androidx.compose.material.icons.outlined.VisibilityOff
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.graphics.Color
import org.gymly.theme.GymlyColors

/** Ícono de ojo para mostrar u ocultar una contraseña. Se usa en todos los campos de contraseña. */
@Composable
fun PasswordVisibilityToggle(
    visible: Boolean,
    onToggle: () -> Unit,
    tint: Color = GymlyColors.TextMuted,
) {
    IconButton(onClick = onToggle) {
        Icon(
            imageVector = if (visible) Icons.Outlined.VisibilityOff else Icons.Outlined.Visibility,
            contentDescription = if (visible) "Ocultar contraseña" else "Mostrar contraseña",
            tint = tint,
        )
    }
}

/** Estado de mostrar u ocultar para un campo de contraseña; empieza oculto. */
@Composable
fun rememberPasswordVisible(): Pair<Boolean, () -> Unit> {
    var visible by remember { mutableStateOf(false) }
    return visible to { visible = !visible }
}
